<div class="content-div">
  <div class="box">
    <h1 class="title">Explore your interests</h1>
    <div class="content-box">
      <div class="desc-box">
        <p class="description">
          This activity helps you discover careers that could be a good fit 
          based on what you enjoy. You’ll see several scenarios with six job options - 
          these are not suggestions for you, just examples to get you thinking.
        </p>

        <p class="description text-bold padding-20">For each scenario: </p>
        <ul>
          <li class="description text-bold">
            Read each job tile carefully.
          </li>
          <li class="description text-bold">
            Stack rank the jobs from the one you’d enjoy most to the one you’d enjoy least.
          </li>
        </ul>

        <p id="ranking-instructions" class="sr-only">
          Rank the activities from 1 to 6. 1 means most enjoyed and 6 means least enjoyed
        </p>

        <p class="description padding-20">
          Be honest — there are no wrong answers! Your rankings will guide you 
          toward careers that align with your interests.
        </p>
      </div>
      
      <img 
        src='/assets/images/survey/option-drag-drop.png' 
        alt=""
        class="drag-drop-img"
      />
    </div>

    <button 
      mat-flat-button 
      type="button" 
      class="survey-btn"
      (click)="startSurveyBtn()"
    >
      Start survey
    </button>
  </div>
</div>
